export enum CardType {
  Fleet = 'Client::Card::Fleet',
  Personal = 'Client::Card::Personal',
}

export const cardTypeTranslation = {
  [CardType.Fleet]: 'Frota',
  [CardType.Personal]: 'Pessoal',
}
